import fetchIntercept from "fetch-intercept";
import { reject } from "lodash";
import { Dispatch } from "redux";
import { expireSession } from "../../redux/actions/authActions";

const httpInterceptor = (dispatch: Dispatch) => {
  fetchIntercept.register({
    response: function (response) {
      response
        .clone()
        .json()
        .then((json) => {
          if (json.status === "error") {
            if (json.type === "relogin") {
              dispatch(expireSession());
            }
          }
        })
        .catch((err) => {
          reject(err);
        });
      return response;
    },
  });
};
export default httpInterceptor;
